export default __webpack_public_path__ + "static/saudi_arabia-saudi-lineage-d6e4302ed930f3a1c823e2ee7bc74e55.jpg";